import { createFileRoute } from "@tanstack/react-router";
import { AnfrageAkte } from "@/pages/team/AnfrageAkte";

/** Die Anfrage-Akte eines Interessenten — reine Team-Seite. */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/anfragen/$id")({
	component: AnfrageAkteSeite,
});

function AnfrageAkteSeite() {
	const { id } = Route.useParams();
	return <AnfrageAkte id={id} />;
}
